import React from "react";
import "./ButtonSpinner.scss";

export const ButtonSpinner = () => {
  return <span className="button-spinner"></span>;
};
